'use client';

import Link from 'next/link';
import { formatPrice } from 'utils';

import { selectPromotion } from '@/modules/google/data-layer/data-layer';
import { HomePageBannerProduct } from '@/modules/home/api';
import { Image } from '@/shared/components/image';
import { routes } from '@/shared/data/routes';
import { useCurrentLocale } from '@/shared/utils/client';
import { productName } from '@/shared/utils/product-name';

import styles from './HomePageProduct.module.scss';
import {
  imageBreakpoints,
  mapHomePageBannerProductToGtmPromotionEventItem,
} from './utils';

export function HomePageProduct({
  product,
  bannerId,
  name,
}: {
  product: (HomePageBannerProduct & { index: number }) | null | undefined;
  bannerId: number;
  name: string;
}) {
  const locale = useCurrentLocale();

  function handleProductClick() {
    if (!product) return;

    selectPromotion(
      name,
      `P${bannerId}`,
      'Moduł produktowy na stronie głównej',
      mapHomePageBannerProductToGtmPromotionEventItem(
        product,
        product.index,
        name,
        'Moduł produktowy na stronie głównej'
      )
    );
  }

  if (!product) return null;

  return (
    <Link
      href={`${routes[locale].SINGLE_PRODUCT}/${product.slug}`}
      prefetch={false}
      className={styles.HomePageProduct__wrapper}
      onClick={handleProductClick}
    >
      <div className={styles.HomePageProduct__image}>
        {!!product.images?.[0] && (
          <Image
            alt={productName(product)}
            src={product.images[0]}
            breakpoints={imageBreakpoints}
          />
        )}
      </div>
      <div className={styles.HomePageProduct__details}>
        <div className={styles.HomePageProduct__price}>
          {formatPrice(product.price, locale)}
          {!!product.previous_price && (
            <>
              {' '}
              <s>{formatPrice(product.previous_price, locale)}</s>
            </>
          )}
        </div>
        <div className={styles.HomePageProduct__title}>
          {productName(product)}
        </div>
      </div>
    </Link>
  );
}
